import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getSecSnackBarProps } from '../../../store/global/selectors';
import { handleSecSnackBar } from '../../../store/global/actions';


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(3),
        },
    },
    snackBar: {
        zIndex: 1501
    }
}));

export default function SecondarySnackbar() {
    const dispatch = useDispatch();
    const classes = useStyles();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(handleSecSnackBar({}, true));
    };

    const { message, severity, ...rest } = useSelector(getSecSnackBarProps);


    return (
        <div className={classes.root} style={{ marginTop: 65 }}>
            <Snackbar {...rest} onClose={handleClose} className={classes.snackBar} key={message}>
                {rest.open && (
                    <Alert onClose={handleClose} severity={severity} style={{ marginTop: 65 }}>
                        {message}
                    </Alert>
                )}
            </Snackbar>
        </div>
    );
}

